import { Button } from '@simplywallst/ui-core/next';
import { Menu, cn } from '@simplywallst/ui-core/next';

import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';
import { ORDERED_MARKETS, PRIMARY_MARKETS } from '@/constants/markets';
import type { BenchmarkType } from '../../hooks';

type Props = {
  label: string;
  option: string;
  setOption: (option: string, type: BenchmarkType) => void;
};

const items = ORDERED_MARKETS.map((market) => ({
  value: market.toUpperCase(),
  label: PRIMARY_MARKETS[market].label,
}));

export const BenchmarkOptionSelect = ({ label, option, setOption }: Props) => {
  return (
    <Menu
      className="max-h-[250px]"
      label={
        <Button
          variant="subtle"
          size="medium"
          className="mr-x1 grid grid-cols-[auto_24px] items-center px-x0_75 text-xs text-soft"
        >
          {label}
          <ChevronDownSmallSolid className="fill-soft" />
        </Button>
      }
    >
      <Menu.Section title="Benchmark to market" className="pt-2 text-soft">
        {items.map((item) => (
          <Menu.Item
            className={cn(item.value === option && 'font-strong')}
            key={item.value}
            isSelected={item.value === option}
            onAction={() => setOption(item.value, 'MARKET')}
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu.Section>
    </Menu>
  );
};
